var map = {
	".": 70,
	"./": 70,
	"./App": 99,
	"./App.tsx": 99,
	"./common-styles": 3,
	"./common-styles/": 3,
	"./common-styles/assets": 86,
	"./common-styles/assets.ts": 86,
	"./common-styles/index": 3,
	"./common-styles/index.tsx": 3,
	"./common-styles/media-queries": 85,
	"./common-styles/media-queries.ts": 85,
	"./common-styles/variables": 87,
	"./common-styles/variables.ts": 87,
	"./components/Carousel": 88,
	"./components/Carousel/": 88,
	"./components/Carousel/BulletPoints": 107,
	"./components/Carousel/BulletPoints.tsx": 107,
	"./components/Carousel/Carousel": 101,
	"./components/Carousel/Carousel.tsx": 101,
	"./components/Carousel/CarouselImageItem": 105,
	"./components/Carousel/CarouselImageItem.tsx": 105,
	"./components/Carousel/CarouselImageList": 103,
	"./components/Carousel/CarouselImageList.tsx": 103,
	"./components/Carousel/ScrollCarousel": 102,
	"./components/Carousel/ScrollCarousel.tsx": 102,
	"./components/Carousel/animateHorizontalScroll": 108,
	"./components/Carousel/animateHorizontalScroll.ts": 108,
	"./components/Carousel/index": 88,
	"./components/Carousel/index.ts": 88,
	"./components/Carousel/useHorizontalDrag": 104,
	"./components/Carousel/useHorizontalDrag.ts": 104,
	"./components/Carousel/useItemInView": 106,
	"./components/Carousel/useItemInView.ts": 106,
	"./components/Heading": 109,
	"./components/Heading.tsx": 109,
	"./components/MarkedButton": 226,
	"./components/MarkedButton.tsx": 226,
	"./components/ResponsiveIndicator": 227,
	"./components/ResponsiveIndicator.tsx": 227,
	"./components/SiteButton": 110,
	"./components/SiteButton.tsx": 110,
	"./components/SiteLinkButton": 51,
	"./components/SiteLinkButton.tsx": 51,
	"./components/Wobble": 92,
	"./components/Wobble/": 92,
	"./components/Wobble/WobbleFilter": 62,
	"./components/Wobble/WobbleFilter.tsx": 62,
	"./components/Wobble/index": 92,
	"./components/Wobble/index.tsx": 92,
	"./components/Wobble/useWobble": 63,
	"./components/Wobble/useWobble.ts": 63,
	"./components/Wobble/wobbleTypes/LinkBoxWobble": 94,
	"./components/Wobble/wobbleTypes/LinkBoxWobble.tsx": 94,
	"./components/Wobble/wobbleTypes/MainTitleWobble": 93,
	"./components/Wobble/wobbleTypes/MainTitleWobble.tsx": 93,
	"./fonts.css": 207,
	"./hooks/useTheme": 111,
	"./hooks/useTheme.ts": 111,
	"./index": 70,
	"./index.css": 218,
	"./index.tsx": 70,
	"./initialization": 157,
	"./initialization.ts": 157,
	"./pages/common/styles": 9,
	"./pages/common/styles.ts": 9,
	"./pages/main": 58,
	"./pages/main/": 58,
	"./pages/main/SDK-loader": 112,
	"./pages/main/SDK-loader.ts": 112,
	"./pages/main/components/Capabilities": 59,
	"./pages/main/components/Capabilities/": 59,
	"./pages/main/components/Capabilities/CapabilityItem": 113,
	"./pages/main/components/Capabilities/CapabilityItem.tsx": 113,
	"./pages/main/components/Capabilities/index": 59,
	"./pages/main/components/Capabilities/index.tsx": 59,
	"./pages/main/components/Capabilities/types": 95,
	"./pages/main/components/Capabilities/types.ts": 95,
	"./pages/main/components/Principles": 60,
	"./pages/main/components/Principles/": 60,
	"./pages/main/components/Principles/PrincipleItem": 114,
	"./pages/main/components/Principles/PrincipleItem.tsx": 114,
	"./pages/main/components/Principles/index": 60,
	"./pages/main/components/Principles/index.tsx": 60,
	"./pages/main/components/Principles/types": 96,
	"./pages/main/components/Principles/types.ts": 96,
	"./pages/main/components/SdkBehaviors": 61,
	"./pages/main/components/SdkBehaviors/": 61,
	"./pages/main/components/SdkBehaviors/SdkBehaviorItem": 116,
	"./pages/main/components/SdkBehaviors/SdkBehaviorItem.tsx": 116,
	"./pages/main/components/SdkBehaviors/SdkBehaviorsList": 115,
	"./pages/main/components/SdkBehaviors/SdkBehaviorsList.tsx": 115,
	"./pages/main/components/SdkBehaviors/behaviors": 118,
	"./pages/main/components/SdkBehaviors/behaviors.json": 118,
	"./pages/main/components/SdkBehaviors/index": 61,
	"./pages/main/components/SdkBehaviors/index.tsx": 61,
	"./pages/main/components/SdkBehaviors/jelloAnimation": 117,
	"./pages/main/components/SdkBehaviors/jelloAnimation.ts": 117,
	"./pages/main/data": 17,
	"./pages/main/data.ts": 17,
	"./pages/main/index": 58,
	"./pages/main/index.tsx": 58,
	"./pages/main/sections/CapablitiesSection": 119,
	"./pages/main/sections/CapablitiesSection.tsx": 119,
	"./pages/main/sections/ContactSection": 120,
	"./pages/main/sections/ContactSection.tsx": 120,
	"./pages/main/sections/DocumentationSection": 121,
	"./pages/main/sections/DocumentationSection.tsx": 121,
	"./pages/main/sections/IntroSection": 100,
	"./pages/main/sections/IntroSection.tsx": 100,
	"./pages/main/sections/PrinciplesSection": 122,
	"./pages/main/sections/PrinciplesSection.tsx": 122,
	"./pages/main/sections/SdkBehaviorsSection": 123,
	"./pages/main/sections/SdkBehaviorsSection.tsx": 123,
	"./reset.css": 206,
	"./resources/base-camp.png": 468,
	"./resources/doc-01-host.svg": 469,
	"./resources/doc-02-build.svg": 470,
	"./resources/flexibility.png": 471,
	"./resources/flexible.svg": 472,
	"./resources/gallery01.png": 473,
	"./resources/gallery02.png": 474,
	"./resources/gallery03.png": 475,
	"./resources/gallery04.gif": 476,
	"./resources/gallery04.png": 477,
	"./resources/gallery05.gif": 478,
	"./resources/gallery05.png": 479,
	"./resources/gallery06.png": 480,
	"./resources/green-stroke.svg": 481,
	"./resources/highlighted-text-instance.png": 482,
	"./resources/img-msging.png": 483,
	"./resources/knowledge.png": 484,
	"./resources/mail-icon.png": 485,
	"./resources/messaging-instance.png": 486,
	"./resources/native-api-documentation.png": 487,
	"./resources/one-service.png": 488,
	"./resources/proactive-instance.png": 489,
	"./resources/quirky-rectangle.svg": 490,
	"./resources/sdk-logo.svg": 491,
	"./resources/sdk-shape.svg": 492,
	"./resources/simplicity.png": 493,
	"./resources/simplicity.svg": 494,
	"./resources/slack-mark.png": 495,
	"./resources/slack.jpg": 496,
	"./resources/unified.svg": 497,
	"./resources/web-api-documentation.png": 498,
	"./resources/welcoming-instance.png": 499,
	"./resources/wizard-instance.png": 500,
	"./static/fonts/ApercuPro-Black.woff": 213,
	"./static/fonts/ApercuPro-Black.woff2": 212,
	"./static/fonts/ApercuPro-Bold.woff": 217,
	"./static/fonts/ApercuPro-Bold.woff2": 216,
	"./static/fonts/ApercuPro-Light.woff": 215,
	"./static/fonts/ApercuPro-Light.woff2": 214,
	"./static/fonts/ApercuPro-LightItalic.woff": 209,
	"./static/fonts/ApercuPro-LightItalic.woff2": 208,
	"./static/fonts/ApercuPro-Regular.woff": 211,
	"./static/fonts/ApercuPro-Regular.woff2": 210,
	"./svg-components/BuildingBlocksIcon": 228,
	"./svg-components/BuildingBlocksIcon.tsx": 228,
	"./svg-components/HomeIcon": 229,
	"./svg-components/HomeIcon.tsx": 229,
	"./theme": 97,
	"./theme/": 97,
	"./theme/index": 97,
	"./theme/index.ts": 97,
	"./utils": 11,
	"./utils.ts": 11
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 443;